import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import Sidebar, { type ViewKey } from './components/Sidebar';
import MobileNav from './components/MobileNav';
import NotesPanel from './components/NotesPanel';
import KnowledgePanel from './components/KnowledgePanel';
import TelegramSettingsModal from './components/TelegramSettingsModal';

export default function Dashboard() {
  const [view, setView] = useState<ViewKey>('notes');
  const [telegramOpen, setTelegramOpen] = useState(false);
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut();
    navigate('/login', { replace: true });
  };

  return (
    <div className="flex h-[100dvh] flex-col overflow-hidden bg-background-50 md:flex-row">
      {/* Desktop Sidebar */}
      <div className="hidden md:block">
        <Sidebar
          active={view}
          onChange={setView}
          onOpenTelegramSettings={() => setTelegramOpen(true)}
          onLogout={handleLogout}
        />
      </div>

      {/* Mobile Bottom Nav */}
      <MobileNav
        active={view}
        onChange={setView}
        onOpenTelegramSettings={() => setTelegramOpen(true)}
        onLogout={handleLogout}
      />

      <main className="flex-1 overflow-hidden bg-background-50 pb-16 md:pb-0">
        {view === 'notes' ? <NotesPanel /> : <KnowledgePanel />}
      </main>

      <TelegramSettingsModal
        open={telegramOpen}
        onClose={() => setTelegramOpen(false)}
      />
    </div>
  );
}